import { render } from "./VistaDetallePedidoInstalados.vue?vue&type=template&id=59893e2e"
import script from "./VistaDetallePedidoInstalados.vue?vue&type=script&lang=js"
export * from "./VistaDetallePedidoInstalados.vue?vue&type=script&lang=js"

import "./VistaDetallePedidoInstalados.vue?vue&type=style&index=0&id=59893e2e&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__